import React, { useState, useEffect, ChangeEventHandler, useRef } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useLocation, useNavigate } from 'react-router-dom'; 
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import CustomButton from "../../components/CustomButton/CustomButton";
import InputField from "../../components/InputField/InputField";
import setInputValues from "../../utils/helpers/setInputValue";
import { ArrowLeft } from "react-bootstrap-icons";
import PageHeader from "../../components/PageHeader/PageHeader";
import CustomMultiSelectDropdown from "../../components/CustomMultiSelectDropdown/CustomMultiSelectDropdown";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import Select from "react-select";
import "./group.scss";
import { customStyles, customSingleSelectStyles} from "../../utils/constants/CustomStyles.constants";

interface Attendee {
   id: number;
   name: string;
}

interface GroupItem {
  id?: number;
  name: string;
  userInfo?: Attendee[];
}
interface SelectOption {
  value: string | number;  // The `value` can be either a string (like 'select_all') or a number (for employee IDs).
  label: string;
}


const GroupForm: React.FunctionComponent = () => {
  const navigate = useNavigate() 
  const [groupInfo, setGroupInfo] = useState<any>({name: "", userInfo: [] }) 
  // const [selectedValue, setSelectedValue] = useState([])
  const [selectedValue, setSelectedValue] = useState<SelectOption[]>([]);

  const cmpMounted = useRef(false)
  const [people, setPeople] = useState<any>([])
  const [dropdownError, setDropdownError] = useState("")
  const dispatch = useAppDispatch()
  const [initialFormState, setInitialFormState] = useState<GroupItem | null>(null)

  const location = useLocation()
  const isEdit = location.state?.isEdit
  const groupId = location.state?.data?.id;

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchPeople();

    if (isEdit && groupId) {
      fetchGroupData(groupId);
      setGroupInfo({
        id: groupId,
        name: location.state.data.name || "",
      });
      setInitialFormState({
        id: groupId,
        name: location.state.data.name || "",
      })
    }
  }, [ groupId]);

  const fetchPeople = async () => {
    try {
      dispatch(showLoader('Loading data...'));
      const response = await postDetails(APIList.GET_ALL_PEOPLES, {});
      const sortedItems = [...response.data]
      sortedItems.sort((a, b) => {
        // return a.name.localeCompare(b.name);
        return a.user_name.localeCompare(b.user_name);
      });
      setPeople(sortedItems);
    } catch (error) {
      console.log("Error fetching employees", error)
      dispatch(showToast(`Error fetching employees`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      if(!isEdit){
        dispatch(hideLoader())
      }
    }
  };

  const fetchGroupData = async (id: number) => {
    try {
      dispatch(showLoader('Loading data...'));

      const response = await postDetails(APIList.GET_GROUP_BY_ID, { id });
      const existingUsers = response.data.userInfo.map((item:any)=> ({
        value: item.id,
        label: item.name
      }))
      // console.log(existingUsers)
      setSelectedValue(existingUsers);
      const attendee_ids = response.data.userInfo.map((item:any)=> item.id)
      setGroupInfo((prevValue: any) => ({...prevValue, attendee_ids}))
      setInitialFormState((prevValue: any) => ({...prevValue, attendee_ids}))
      dispatch(hideLoader())

    } catch (error) {
      console.log("Error fetching group details", error);
      dispatch(showToast(`Error fetching group details`));
      setTimeout(() => dispatch(hideToast()), 3000);
      dispatch(hideLoader())
    }
  };

  // const handleSelection = (selectedItems: any) => {
  //   // console.log(selectedItems)
  //   setSelectedValue(selectedItems);
  //   const attendee_ids = selectedItems.map((item: any) => item.value)
  //   setGroupInfo({...groupInfo, attendee_ids})
  // };
  const handleSelection = (selectedItems: any) => {
    // Check if "Select All" is selected
    const isSelectAll = selectedItems.some((item: any) => item.value === 'select_all');
  
    if (isSelectAll) {
      if (selectedItems.length === options.length) {
        // If "Select All" is selected and all employees are selected, deselect all
        setSelectedValue([]);
        setGroupInfo({ ...groupInfo, attendee_ids: [] });
      } else {
        // Select all employees
        const allOptions = options.filter(option => option.value !== 'select_all'); // Exclude 'Select All' option from selection
        setSelectedValue(allOptions);
        const attendee_ids = allOptions.map((item: any) => item.value);
        setGroupInfo({ ...groupInfo, attendee_ids });
      }
    } else {
      // Normal selection without "Select All"
      setSelectedValue(selectedItems);
      const attendee_ids = selectedItems.map((item: any) => item.value);
      setGroupInfo({ ...groupInfo, attendee_ids });
    }
  };
  

  const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault()

    if (JSON.stringify(groupInfo) === JSON.stringify(initialFormState)) {
      dispatch(showToast(`No changes done.`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if(!groupInfo.attendee_ids || groupInfo.attendee_ids.length === 0 ){
      setDropdownError("Employee field is required")
      return
    }
    setDropdownError("")
    // console.log(groupInfo)
   try {
    dispatch(showLoader("Loading Data..."));

     const response = await postDetails(APIList.ADD_GROUP, groupInfo)
    //  console.log(response)

     if(response.status === "Failed"){
       dispatch(showToast(response.message));
       setTimeout(() => dispatch(hideToast()), 3000);
      //  dispatch(hideLoader());
       return
     }

    else if(response.statusCode === "10005"){
      dispatch(showToast("Server error. Please try again later"));
      setTimeout(() => dispatch(hideToast()), 3000);
      // dispatch(hideLoader());
      return
     }
 
    else if(response.statusCode === 200){
     setGroupInfo({
       id: "",
       name: "",
       attendee_ids: [],
      })
      dispatch(hideLoader());
      dispatch(showToast(isEdit ? "Group Updated Successfully" : "Group Added Successfully"));
        setTimeout(() => dispatch(hideToast()), 3000);
  
      navigate("/group")
     }

     else{
      // dispatch(hideLoader());
      dispatch(showToast("Some error occurred while submitting data"));
        setTimeout(() => dispatch(hideToast()), 3000);
  
     }

   } catch (error) {
    console.log("An unexpected error occurred.", error);
    dispatch(showToast("An unexpected error occurred."));
    setTimeout(() => dispatch(hideToast()), 3000);
    dispatch(hideLoader());
   }finally{
      dispatch(hideLoader());
    }
  };

  const handleBackToGroup = ()=>{
    setGroupInfo({
      name: "",
      attendee_ids: [],
    })
    navigate("/group");
  }

  const buttons = [
    {
      label: "Back To Group List",
      theme: "danger",
      icon: <ArrowLeft />,
      onClick: handleBackToGroup,
    }
  ];

  // const options = people.map((item:any) => ({ value: item.id, label: item.name }));
  const options = [
    { value: 'select_all', label: 'Select All' }, // Select All option
    // ...people.map((item: any) => ({ value: item.id, label: item.name }))
    ...people.map((item: any) => ({ value: item.id, label: item.user_name }))
  ];
  return (
    <LayoutContainer title="People">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className={`page-header-icon fa fa-${isEdit ? "pencil" : "plus"}`}></i>
          { isEdit ? "Edit Group" : "Create New Group"}
        </h2>
      <PageHeader buttons={buttons} />
      </div>
      <div className="mx-4">
        <form className="add-group-form" onSubmit={handleSubmit}>
              <div className="group-form-container d-flex flex-column">
              <div className="input-field-wrapper">
              <InputField
                name="name"
                label="Group Name"
                type="text"
                value={groupInfo.name}
                placeholder="Enter Group Name"
                minLength={3}
                maxLength={50}
                required={true}
                onChangeInput={ev => setInputValues(ev, groupInfo, setGroupInfo)}
              />
              </div>
              
              <div className="font-12" style={{minHeight: "100px"}}>
              <label htmlFor="people" className="mb-1 weight-500">Add Employees to Group <span className="text-danger">*</span></label>
              <Select
                styles={customStyles}
                isMulti
                closeMenuOnSelect={false}
                name="people"
                id="people"
                options={options}
                // required={true}
                onChange={handleSelection}
                placeholder="Select Employees"
                value={selectedValue}
              />
              {dropdownError 
              && 
              <p 
              className="mt-1 error-text"
              style={{fontSize: "11.2px"}}
              >{dropdownError}</p>
              }
              </div>

          <div>
            <CustomButton type="submit" size="md" theme="red">
            { isEdit ? "Update" : "Submit"}
            </CustomButton>
          </div>
          </div>
        </form>
      </div>
    </LayoutContainer>
  );
};

export default GroupForm;
